/*
 * @Author: Pension 744056574@qq.com
 * @Date: 2022-08-23 15:49:53
 * @LastEditors: Pension 744056574@qq.com
 * @LastEditTime: 2022-09-20 17:36:09
 * @FilePath: /njyx-frontend-pc/packages/main/src/permission.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import router from "./router";

const whiteList = ["/login", "/findpwd", "/h5login", "/bargain"];
router.beforeEach((to, from, next) => {
  const hasToken = window.localStorage.getItem("token");
  if (hasToken) {
    if (to.path === "/login") {
      next({
        path: "/login",
        query: {
          timeStamp: new Date().getTime()
        }
      });
      localStorage.clear();
    } else {
      next();
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next({
        path: "/login",
        query: {
          timeStamp: new Date().getTime()
        }
      });
    }
    localStorage.clear();
  }
});
